/**
 * Keeps Recharts' d3 scale implementations alive through Bun's bundler.
 *
 * Recharts resolves scales by building the export name at runtime:
 *   d3Scales[realScaleType]  /  d3Scales[`scale${upperFirst(realScaleType)}`]
 * (see recharts/es6/state/selectors/axisSelectors.js).
 *
 * Bun's dead-code elimination cannot see those dynamic lookups, so it strips
 * the implementations while still emitting the namespace export binding, e.g.
 * `scalePoint: () => cmb` where `cmb` is never declared. The first chart that
 * uses a band/point/time axis then throws `ReferenceError: cmb is not defined`,
 * React unmounts the whole tree, and the dashboard renders as a BLANK PAGE with
 * no server-side error at all.
 *
 * Referencing each export statically below makes them reachable, so they survive
 * the bundle. Do not delete, and do not "optimise" this into a loop or a
 * dynamic lookup -- it has to stay statically analysable to do its job.
 */
import * as d3Scales from "victory-vendor/d3-scale";

const retained = [
  d3Scales.scaleBand,
  d3Scales.scalePoint,
  d3Scales.scaleIdentity,
  d3Scales.scaleLinear,
  d3Scales.scaleLog,
  d3Scales.scalePow,
  d3Scales.scaleSqrt,
  d3Scales.scaleSymlog,
  d3Scales.scaleTime,
  d3Scales.scaleUtc,
  d3Scales.scaleQuantile,
  d3Scales.scaleQuantize,
  d3Scales.scaleThreshold,
  d3Scales.scaleOrdinal,
  d3Scales.scaleRadial,
  d3Scales.scaleSequential,
  d3Scales.scaleSequentialLog,
  d3Scales.scaleSequentialPow,
  d3Scales.scaleSequentialSqrt,
  d3Scales.scaleSequentialSymlog,
  d3Scales.scaleSequentialQuantile,
  d3Scales.scaleDiverging,
  d3Scales.scaleDivergingLog,
  d3Scales.scaleDivergingPow,
  d3Scales.scaleDivergingSqrt,
  d3Scales.scaleDivergingSymlog,
];

// Assigning to a global keeps the array itself from being elided.
(globalThis as unknown as Record<string, unknown>).__rechartsScalesRetained = retained.length;

export {};
